import { useState, useEffect } from "react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/solid";
import { useNavigate, useSearchParams } from "react-router-dom";
import toast from "react-hot-toast";

import api from "@/services/api";
import useStore from "@/services/store";
import Loader from "@/components/Loader";

const SignupValuationGame = () => {
  const [errors, setErrors] = useState({ password: "" });
  const navigate = useNavigate();
  const { setUser } = useStore();
  const [loading, setLoading] = useState(false);
  const [seePassword, setSeePassword] = useState(false);
  const [values, setValues] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    agree: false,
  });

  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  useEffect(() => {
    if (!token) {
      toast.error("Aucun token de connexion trouvé");
      navigate("/home");
      return;
    }

    const fetchData = async () => {
      try {
        setLoading(true);
        const { ok, data, code } = await api.get(`/user/valuation-game?valuation_game_token=${token}`);
        if (!ok) {
          if (code === "NOT_FOUND") {
            toast.error("Aucun utilisateur trouvé");
            navigate("/home");
            return;
          }
          return toast.error("Une erreur est survenue");
        }
        setValues(data);
      } catch (error) {
        console.error(error);
        toast.error("Une erreur est survenue");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    try {
      const { ok, data, code } = await api.put(`/user/valuation-game`, { valuation_game_token: token, password: values.password });
      if (!ok) {
        if (code === "PASSWORD_NOT_VALIDATED") return setErrors({ ...errors, password: "Le mot de passe doit faire entre 6 et 100 caractères et contenir au moins 1 lettre" });
        throw new Error("Une erreur est survenue");
      }
      api.setToken(data.token);
      setUser(data.user);
      if (!data.company) return navigate("/home");
      else navigate(`/valuation-game-result/${data.company.company_type?.toLowerCase() || "start-up"}/${data.company._id}`);
    } catch (error) {
      console.error(error);
      toast.error("Une erreur est survenue");
    }
  };

  if (loading) return <Loader />;

  return (
    <div className="w-full pb-20">
      <header className="w-full mb-8">
        <h1 className="text-center text-4xl font-bold text-gray-800 mb-4">Finalisez votre inscription</h1>
        <p className="text-base text-center text-gray-500">pour accéder à Linkera</p>
      </header>
      <div className="w-full space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div className="space-y-2">
            <label className="text-base font-medium" htmlFor="first_name">
              Prénom
            </label>
            <input className="input" name="first_name" value={values.first_name || ""} onChange={(e) => setValues({ ...values, first_name: e.target.value })} />
          </div>
          <div className="space-y-2">
            <label className="text-base font-medium" htmlFor="last_name">
              Nom
            </label>
            <input className="input" name="last_name" value={values.last_name || ""} onChange={(e) => setValues({ ...values, last_name: e.target.value })} />
          </div>
        </div>
        <div className="space-y-2">
          <label className="text-base font-medium" htmlFor="organization-email">
            E-mail
          </label>
          <input type="email" className="input" name="organization-email" value={values.email || ""} disabled />
        </div>
        <div className="space-y-2">
          <label className="text-base font-medium" htmlFor="password">
            Mot de passe
          </label>
          <div className="relative">
            <input
              type={seePassword ? "text" : "password"}
              name="password"
              className="input"
              value={values.password || ""}
              onChange={(e) => {
                setValues({ ...values, password: e.target.value });
                setErrors({ ...errors, password: "" });
              }}
            />
            <div className="absolute top-1/2 -translate-y-1/2 right-4">
              {seePassword ? (
                <EyeSlashIcon className="w-6 h-6 text-primary cursor-pointer" onClick={() => setSeePassword(false)} />
              ) : (
                <EyeIcon className="w-6 h-6 text-primary cursor-pointer" onClick={() => setSeePassword(true)} />
              )}
            </div>
          </div>
          {errors.password && <p className="text-xs text-red-700">{errors.password}</p>}
        </div>
        <button type="button" disabled={errors.password || !values.password} className="primary-button w-full !mt-10" onClick={handleSubmit}>
          Continuer
        </button>
      </div>
    </div>
  );
};

export default SignupValuationGame;
